<template>
  <div>
    <Header/>
    <Features/>
    <DetailedFeatures/>
  </div>
</template>

<script>
    import Header from "./Header";
    import DetailedFeatures from "./DetailedFeatures";
    import Features from "./Features";
    export default {
        name: "Main",
      components: {Features, DetailedFeatures, Header},
      created() {
        this.$store.commit("SET_PAGE_TYPE", "company");
        this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "linear-gradient(242.81deg, #5BBAFF -59.72%, #3834FD 94.95%)");
        // console.log("Background Color", this.$store.state.pageFooterBackgroundColor);
      }
    }
</script>

<style scoped>

</style>
